import ic365 from '@/assets/sponsors/365.png';
import icGDT from '@/assets/sponsors/GDT_Monocromatica.png';
import icClarin from '@/assets/sponsors/clarin.png';
import icOle from '@/assets/sponsors/ole.jpg';
import icTn from '@/assets/sponsors/tn.png';

export const SponsorsFieldLayout = () => {
  return (
    <div className="sponsors gap-10 z-[1] absolute flex justify-center items-center top-[3.4rem] translate-x-[-50%] left-1/2 w-[33.5rem] h-10">
      <figure>
        <img
          alt="Logotipo Clarin"
          className="cursor-pointer"
          src={icClarin}
          style={{ width: '6.2rem' }}
          onClick={() => window.open('http://www.clarin.com/')}
        />
      </figure>
      <figure>
        <img
          alt="Logotipo Clarin Olé"
          className="cursor-pointer"
          src={icOle}
          style={{ width: '2.3rem' }}
          onClick={() => window.open('https://www.ole.com.ar/')}
        />
      </figure>
      <figure>
        <img
          alt="Logotipo Schneider"
          className="cursor-pointer mr-4"
          src={icGDT}
          style={{ width: '2.5rem' }}
          onClick={() => window.open('https://www.cervezaschneider.com.ar/')}
        />
      </figure>
      <figure>
        <img
          alt="Logotipo Clarín 365"
          className="cursor-pointer mr-4"
          src={ic365}
          style={{ width: '2.2rem' }}
          onClick={() => window.open('https://365.clarin.com/')}
        />
      </figure>
      <figure>
        <img
          alt="Logotipo Todo Noticias"
          className="cursor-pointer mr-4"
          src={icTn}
          style={{ width: '3.8rem' }}
          onClick={() => window.open('https://tn.com.ar/')}
        />
      </figure>
    </div>
  );
};
